import { DTOBillingInterval, DTOProductCode } from "./enums";
import z from "zod";
export const DTOBillingSupportedModels = z.enum([
    "GPT_4_1",
    "GPT_4_1_MINI",
    "GPT_4O",
    "O1",
    "GPT_5",
    "GPT_5_MINI",
    "GPT_5_NANO",
    "GPT_5_2_CODEX",
    "GPT_5_3_CODEX",
    "GPT_5_4",
    "GPT_5_5",
    // Claude models
    "CLAUDE_OPUS_4_0",
    "CLAUDE_OPUS_4_1",
    "CLAUDE_OPUS_4_5",
    "CLAUDE_SONNET_4_0",
    "CLAUDE_SONNET_4_5",
    "CLAUDE_HAIKU_4_5",
    // Claude dated models
    "CLAUDE_OPUS_4_20250514",
    "CLAUDE_OPUS_4_1_20250805",
    "CLAUDE_OPUS_4_5_20251101",
    "CLAUDE_3_7_SONNET_20250219",
    "CLAUDE_3_7_SONNET_LATEST",
    "CLAUDE_SONNET_4_20250514",
    "CLAUDE_SONNET_4_5_20250929",
    "CLAUDE_3_HAIKU_20240307",
    "CLAUDE_3_5_HAIKU_20241022",
    "CLAUDE_3_5_HAIKU_LATEST",
    "CLAUDE_HAIKU_4_5_20251001",
]);
export const DTOBillingCheckoutMode = z.enum([
    "SubscriptionChange",
    "CreditsTopUp",
]);
export const DTOBillingCreditsSpendAction = z.enum([
    "Ask",
    "Build",
    "DocumentUpdate",
]);
//
// Subscription Preview
//
export const DTOBillingSubscriptionChangePreviewInput = z.object({
    plan: DTOProductCode,
    interval: DTOBillingInterval,
    fullSeats: z.number(),
    builderSeats: z.number(),
    additionalCredits: z.number(),
});
//
// Credits Spend
//
export const DTOBillingCreditsSpendInput = z.object({
    patTokenType: z.enum(["User", "Workspace"]).optional(),
    patTokenId: z.string().optional(),
    inputTokenCount: z.number().int().nonnegative(),
    outputTokenCount: z.number().int().nonnegative(),
    inputCachedTokenCount: z.number().int().nonnegative().optional(),
    modelName: DTOBillingSupportedModels,
    action: DTOBillingCreditsSpendAction.optional().default(DTOBillingCreditsSpendAction.enum.Ask),
});
export const DTOBillingUsageEntry = z.object({
    executionId: z.string(),
    parentExecutionId: z.string().optional(),
    executionKind: z.enum(["root", "subagent"]),
    agent: z.string(),
    modelName: DTOBillingSupportedModels,
    providerRequestId: z.string().optional(),
    inputTokenCount: z.number().int().nonnegative(),
    outputTokenCount: z.number().int().nonnegative(),
    inputCachedTokenCount: z.number().int().nonnegative().optional(),
    reasoningTokenCount: z.number().int().nonnegative().optional(),
});
export const DTOBillingUsageSummary = z.object({
    rootAction: DTOBillingCreditsSpendAction,
    entries: z.array(DTOBillingUsageEntry),
});
export const DTOBillingCreditsSpendResponse = z.object({
    hasOverspend: z.boolean(),
});
export const DTOBillingCreditsCheckIfCanSpendResponse = z.object({
    canSpendCredits: z.boolean(),
});
//
// Checkout
//
export const DTOBillingCheckoutOldInput = z.object({
    mode: z.literal(undefined),
    successUrl: z.string().url(),
    cancelUrl: z.string().url(),
    priceId: z.string(),
    quantity: z.number().int().min(1),
}, { description: "It is deprecated, keep for backwards compatibility" });
export const DTOBillingCheckoutSubscriptionChangeInput = z.object({
    mode: z.literal(DTOBillingCheckoutMode.enum.SubscriptionChange),
    successUrl: z.string().url(),
    cancelUrl: z.string().url(),
    plan: DTOProductCode,
    interval: DTOBillingInterval,
    fullSeats: z.number(),
    builderSeats: z.number(),
    additionalCredits: z.number(),
});
export const DTOBillingCheckoutCreditsTopUpInput = z.object({
    mode: z.literal(DTOBillingCheckoutMode.enum.CreditsTopUp),
    successUrl: z.string().url(),
    cancelUrl: z.string().url(),
    centAmount: z.number().int().nonnegative().min(1000),
});
export const DTOBillingCheckoutInput = z.discriminatedUnion("mode", [
    DTOBillingCheckoutOldInput,
    DTOBillingCheckoutSubscriptionChangeInput,
    DTOBillingCheckoutCreditsTopUpInput,
]);
export const DTOBillingCheckoutResponse = z.object({
    id: z.string(),
    url: z.string().nullish(),
});
